import {Stack, css, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	${({theme}) => css`
		::-webkit-scrollbar {
			height: 4px;
		}

		::-webkit-scrollbar-track {
			background: transparent;
			border-radius: 4px;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px;
			background: ${theme.palette.action.disabled};
		}

		::-webkit-scrollbar-thumb:hover {
			background: ${theme.palette.action.disabled};
		}
	`}
`;
